import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { withNamespaces } from 'react-i18next';

class ViewAppFeedbackAnswerComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    rowClassName(rowData) {

        // let IsEnabled = rowData.IsEnabled;

        return { 'p-highlight': true };

    }
    rowExpansionTemplate = (data) => {
        var arraynew = [
            {
                "quesId": "",
                "ansId": "",
                "QuestionType": "",
                "Question": "",
                "Answer": "",
                // "MissionId": "",
                "UpdatedDate": ""
            }
        ]
        let temp1 = data.answerList;
        for (let i = 0; i < temp1.length; i++) {
            if (arraynew.findIndex((element) => element.quesId == temp1[i].QuestionId) != -1) {
                let ind = arraynew.findIndex((element) => element.quesId == temp1[i].QuestionId);
                arraynew[ind].ansId += ',' + temp1[i].AnswerId
                arraynew[ind].Answer += ' , ' + temp1[i].Answer

            }
            else {
                arraynew.push({
                    "quesId": temp1[i].QuestionId,
                    "ansId": temp1[i].AnswerId,
                    QuestionType: temp1[i].QuestionType,
                    Question: temp1[i].Question,
                    Answer: temp1[i].Answer,
                    // MissionId: temp1[i].MissionId,
                    UpdatedDate: temp1[i].CreatedDate
                })
            }

        }
        arraynew.splice(0, 1);
        const { t } = this.props;
        return (
            <div className="orders-subtable">
                <DataTable 
                    className="table"
                    value={arraynew}
                    paginator={true} rows={10}
                    rowClassName={this.rowClassName}
                    responsiveLayout="scroll" 
                    emptyMessage={t('Feedback Setting.No records found')}
                >
                    <Column field="QuestionType" header={t('Feedback Setting.Question Type')} sortable={true} />
                    <Column field="Question" header={t('First_Responder.Question')} sortable={true} />
                    <Column field="Answer" header={t('First_Responder.Answer')} sortable={true} />
                    <Column field="UpdatedDate" body={this.UpdatedDate} header='Updated Date' />
                </DataTable>
            </div>
        );
    }
    UpdatedDate(rowData) {
        if (rowData.UpdatedDate != null &&  rowData.UpdatedDate != undefined) {
            if(rowData.UpdatedDate == "0001-01-01T00:00:00"){
                return;
            }
            else{
                let value = rowData.UpdatedDate.split('T');
                let data = value[1].split(':');
                return (<p>{value[0] + " " + data[0] + ":" + data[1]}</p>) 
            }
        }
    }
    


    render() {
        const { t } = this.props;
        
        var header = <div className="search-name">
            <i className="fa fa-search" style={{ margin: '4px 4px 0 0' }}></i>
            <InputText type="text" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder={t('First_Responder.Search')} size="50" />
        </div>;
        return (
            <div>
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Feedback Setting.Application Feedback answer list')}</h2>
                </div>
                <div className=" forms-panel w3-last-form">
                    <div className="forms add-device">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">

                                <div className="w3l_search">
                                    {header}
                                </div>
                                <div className="devicestable">
                                    <br />

                                    <DataTable
                                        className="table"
                                        value={this.props.feedbackAnswerList.answerList}
                                        loading={this.props.feedbackAnswerList.isLoading}
                                        paginator={true} rows={10}
                                        globalFilter={this.state.globalFilter}
                                        emptyMessage={t('Feedback Setting.No records found')}
                                        rowExpansionTemplate={this.rowExpansionTemplate}
                                        onRowToggle={(e) => this.setState({ expandedRows: e.data })}
                                        expandedRows={this.state.expandedRows}
                                    >
                                        <Column expander style={{ width: '3em' }} />
                                        {/* <Column field="UserId" header="" className="noDisplay" sortable={true} />
                                        <Column field="DeviceId" header="" className="noDisplay" sortable={true} /> */}

                                        <Column field="FirstName" header={t('First_Responder.First Name')} sortable={true} />
                                        <Column field="LastName" header={t('First_Responder.Last Name')} sortable={true} />
                                        <Column field="EmailId" header={t('First_Responder.Email')} sortable={true} />
                                        <Column field="PhoneNumber" header={t('First_Responder.Phone Number')} sortable={true} />

                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withNamespaces()(withRouter(ViewAppFeedbackAnswerComponent));
